export default "__VITE_ASSET__DFqVxbo3__"